<script>
    export let map_id
    export let lat
    export let lng
    import { _ } from 'svelte-i18n';
    import { url } from '../stores/url.js';
    import { user } from '../stores/user.js';
    import { users } from '../stores/users.js';
    import { date, hhmm, padNumber } from '../functions/html-helpers';
    import { getUsers, request } from '../functions/http-helpers.js';
    import { onMount } from 'svelte';
    import uikit from 'uikit'; 
    import { createEventDispatcher } from 'svelte';
    import { Loader } from '@googlemaps/js-api-loader';

  

    onMount(() => {
        const loader = new Loader({
            apiKey: "AIzaSyBAjp22H1_WUNm_-NcCWdxoFSaaKgj353s", 
            // me: AIzaSyA6jSfLvrDKQ09UbgBGsTPYxKzm6Xak9vI 
            // bki: AIzaSyBAjp22H1_WUNm_-NcCWdxoFSaaKgj353s
            version: "weekly",
            libraries: ["places"] 
        });

        const mapOptions = {
            center: {
                lat: parseFloat(lat),
                lng: parseFloat(lng), 
            },
            zoom: 15,
            streetViewControl: false,  // Disable the Street View control
            mapTypeControl: false,  // Disable the map type control
            fullscreenControl: false // Disable the fullscreen control
        };

        // Promise for a specific library
        loader
            .importLibrary('maps')
            .then(({ Map }) => {
                const map = new Map(document.getElementById(map_id), mapOptions);

                loader.importLibrary('marker').then(({ Marker }) => {
                    console.log('Marker')
                    console.log(Marker)
                    const marker = new Marker({
                        position: {
                            lat: parseFloat(lat),
                            lng: parseFloat(lng), 
                        },
                        map: map
                    });
                })
            })
            .catch((e) => {
                console.log('catch')
                console.log(e)
            });
    })

</script>




<div>
    <div class="uk-width-1-1" style="height: 200px" id={`${map_id}`}></div>
</div>